module.exports = __webpack_public_path__ + "static/img/process_img.e26c7bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/process_img.png
// module id = 7FyZ
// module chunks = 1